<template>
  <div class="error-page-wrap" ref="page-wrap">
    <div class="error-cnt">
      <img :src="errorImage" />
      <p>{{ errorMessage }}</p>
      <p v-if="buttonView && returnUrl">
        <a :href="returnUrl" class="btn">{{ $t('点击重试') }}</a>
      </p>
    </div>
  </div>
</template>
<script>
import getTranslation from '@/locale/getTranslation'
export default {
  data() {
    return {
      isMobile: window.isMobile,
      errorState: '',
      errorImage: '',
      errorMessage: '',
      buttonView: false,
      returnUrl: this.$route.query.returnUrl
    }
  },
  beforeMount() {
    this.errorState = this.$route.path.split('/')[2]
  },
  mounted() {
    if (!this.isMobile) {
      let _height = document.documentElement.clientHeight - 180 - 220
      this.$refs['page-wrap'].style.height = _height + 'px'
    }
  },
  watch: {
    errorState() {
      switch (this.errorState) {
        case 'busy':
          this.errorImage = require('../assets/errors/busy.png')
          this.errorMessage = getTranslation('系统繁忙，请稍后重试~')
          this.buttonView = false
          break
        case 'request-fail':
          this.errorImage = require('../assets/errors/no-permission.png')
          this.errorMessage = getTranslation('请求失败，请稍后重试~')
          this.buttonView = false
          break
        case 'no-resule':
          this.errorImage = require('../assets/errors/no-data.png')
          this.errorMessage = getTranslation('暂无结果')
          this.buttonView = false
          break
        case 'no-response':
          this.errorImage = require('../assets/errors/503.png')
          this.errorMessage = getTranslation('服务器未响应~')
          this.buttonView = false
          break
        case 'no-permission':
          this.errorImage = require('../assets/errors/no-permission.png')
          this.errorMessage = getTranslation('对不起，你无此操作权限')
          this.buttonView = false
          break
        case '404':
          this.errorImage = require('../assets/errors/404.png')
          this.errorMessage = getTranslation('您访问的页面找不到了~')
          this.buttonView = true
          break
        case 'no-network':
          this.errorImage = require('../assets/errors/no-net.png')
          this.errorMessage = getTranslation('无法连接网络，请检查网络或重试~')
          this.buttonView = true
          break
        case 'no-English':
          this.errorImage = require('../assets/errors/404.png')
          this.errorMessage = ''
          break
        default:
          this.errorImage = require('../assets/errors/404.png')
          this.errorMessage = getTranslation('系统繁忙，请稍后重试~')
      }
    }
  },
  methods: {}
}
</script>
<style lang="scss">
@media only screen and (max-width: 800px) {
  // .mainCon{
  //   min-height: 100vh;
  // }
  .error-page-wrap {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: #fff;

    .error-cnt {
      position: absolute;
      left: 50%;
      top: 30%;
      width: 6.4rem;
      text-align: center;
      transform: translate(-50%, -50%);

      img {
        width: 4rem;
        height: auto;
        margin: 0 0 1.2rem;
      }
      p {
        margin: 0 0 0.3rem;
        color: #333;
        font-size: 0.28rem;
        text-align: center;
        line-height: 0.4rem;

        &:last-child {
          margin-bottom: 0;
        }

        a.btn {
          display: inline-block;
          width: 2.4rem;
          height: 0.8rem;
          border-radius: 0.4rem;
          border: 1px solid #bbb;
          background: #fff;
          color: #666;
          font-size: 0.28rem;
          text-align: center;
          line-height: 0.76rem;
        }
      }
    }
  }
}
@media only screen and (min-width: 800px) {
  .error-page-wrap {
    position: relative;
    min-height: 480px;
    background: #fff;
    text-align: center;

    .error-cnt {
      position: absolute;
      left: 50%;
      top: 40%;
      width: 320px;
      text-align: center;
      transform: translate(-50%, -50%);

      img {
        width: 240px;
        height: auto;
        margin: 0 0 30px;
      }
      p {
        margin: 0 0 15px;
        color: #333;
        font-size: 14px;
        text-align: center;
        line-height: 20px;

        &:last-child {
          margin-bottom: 0;
        }

        a.btn {
          display: inline-block;
          width: 120px;
          height: 40px;
          border-radius: 20px;
          border: 1px solid #bbb;
          background: #fff;
          color: #666;
          font-size: 14px;
          text-align: center;
          line-height: 38px;
        }
      }
    }
  }
}
</style>
